import React from "react";
import PropTypes from "prop-types";
import { Field, withFormik } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./userFilter.data.form";
import { InputSelect, InputText } from "@de-prado-dev/react-component-library";
import { ACTIVE_STATUS } from "../../../../constants/index";

const UserFilterForm = (props) => {
  const { t } = useTranslation();
  const { handleSubmit, onClean, isTechnical, viveros } = props;

  const renderListUser = (item) => {
    return `${item.name} ${item.surname}`;
  };

  return (
    <div className="row no-margin">
      <div className="col-12 mb-3">
        <div className="accordion" id="workingPartFilter">
          <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingOne">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseOne"
                aria-expanded="false"
                aria-controls="flush-collapseOne"
              >
                {t("forms.users.filter")}
              </button>
            </h2>
            <div
              id="flush-collapseOne"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingOne"
              data-bs-parent="#workingPartFilter"
            >
              <div className="accordion-body">
                <form
                  className="form-horizontal"
                  onSubmit={handleSubmit}
                  autoComplete="off"
                >
                  <div className="row">
                    {!isTechnical && (
                      <div className="col-12 col-md-4">
                        <Field
                          id="name"
                          className="form-control"
                          labelField={t("forms.user.labels.name")}
                          name="name"
                          component={InputText}
                          fieldType="text"
                        />
                      </div>
                    )}

                    <div className="col-12 col-md-3 mt-2 mt-md-0">
                      <Field
                        id="email"
                        labelField={t("forms.user.labels.email")}
                        className="form-control"
                        name="email"
                        component={InputText}
                        language="es"
                        fieldType="text"
                      />
                    </div>
                    <div className="col-12 col-md-2 mt-2 mt-md-0">
                      <Field
                        id="viveroUuid"
                        name="viveroUuid"
                        labelField={t("forms.users.labels.vivero")}
                        // className="form-control"
                        component={InputSelect}
                        placeholder=""
                        optionLabel="label"
                        optionValue="uuid"
                        options={viveros.map((item) => ({
                          ...item,
                          label: item.name,
                        }))}
                        addOptionEmpty
                        classNamePrefix="dark"
                      />
                    </div>
                    <div className="col-12 col-md-2 mt-2 mt-md-0">
                      <Field
                        id="active"
                        name="active"
                        labelField={t("forms.user.labels.active")}
                        // className="form-control"
                        component={InputSelect}
                        placeholder=""
                        optionLabel="label"
                        optionValue="code"
                        options={ACTIVE_STATUS.map((item) => ({
                          ...item,
                          label: t(item.label),
                        }))}
                        addOptionEmpty
                        classNamePrefix="dark"
                      />
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-12 d-flex justify-content-end">
                      <button
                        type="submit"
                        className="btn btn-lg btn-primary me-2"
                      >
                        <i className="fas fa-search"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-lg btn-danger"
                        onClick={() => onClean(props.resetForm)}
                        title={t("cleanFilter")}
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

UserFilterForm.propTypes = {
  handleSubmit: PropTypes.func,
  onClean: PropTypes.func,
};

const UserFilterFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: validationDataModel,
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "UserFilterForm",
})(UserFilterForm);

export default UserFilterFormF;
